import React, { useState, useEffect } from 'react';
import { Alert } from 'react-bootstrap';
import { flowLaunchesChartOptions, seriesColours } from '../../constants';
import { getLaunchesByFlow } from '../../sources/dashboard';
import GenericChart from '../generic/GenericChart';
import Loader from '../Loader';

export const formatData = (response) => {
    const formattedChartData = [];

    response.forEach((dataSet, index) => {
        if (dataSet.flowLaunchTotal) {
            const formattedData = dataSet.flowLaunchData.map(dp => ({ x: dp.bucket, y: dp.counter }));

            formattedChartData.push(
                {
                    data: formattedData,
                    label: dataSet.flowName,
                    backgroundColor: seriesColours[index],
                    borderColor: seriesColours[index],
                },
            );
        }
    });

    return formattedChartData;
};

const FlowLaunchesChart = ({ title, flows, interval, authenticationToken }) => {
    const [chartErrors, setChartErrors] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [chartLabels, setChartLabels] = useState([]);
    const [chartData, setChartData] = useState([]);

    const fetchData = () => {
        setIsLoading(true);

        const flowDataRequests = flows.map(flow => getLaunchesByFlow({
            token: authenticationToken,
            flowId: flow.id,
            params: { interval },
        }));

        Promise.all(flowDataRequests)
            .then((responses) => {
                // Pull out buckets from first data set so they can be used as labels in the chart.
                const labels = responses[0].flowLaunchData.map(dp => dp.bucket);
                // Re-format the data so the chart library can use it.
                const data = formatData(responses);

                setChartLabels(labels);
                setChartData(data);
                setIsLoading(false);
            })
            .catch((error) => {
                const currErrors = [...chartErrors];
                currErrors.push(`Error: ${JSON.parse(error.message).message}`);
                setChartErrors(currErrors);
                setIsLoading(false);
            });
    };

    useEffect(() => {
        if (flows.length && !isLoading) {
            fetchData();
        }
    }, [flows, interval]);

    const renderErrors = () => chartErrors.map((error, index) => (
        <Alert bsStyle="danger" key={index}>
            <p><strong>{error}</strong></p>
        </Alert>
    ));

    const renderChart = () => {
        const chartProps = {
            options: flowLaunchesChartOptions,
            type: 'bar',
            width: '1000',
            height: '200',
            title,
            data: {
                labels: chartLabels,
                datasets: chartData,
            },
        };

        return (chartData.length && !isLoading)
            ? (<GenericChart {...chartProps} />)
            : !chartErrors.length
                ? (<div className="table-no-results-message">No Launches To Display</div>)
                : null;
    };

    return (
        <div style={{ position: 'relative', minHeight: '360px' }}>
            {
                isLoading
                    ? (<Loader message="Loading Flow Launches" />)
                    : (
                        <>
                            {renderErrors()}
                            {renderChart()}
                        </>
                    )
            }
        </div>
    );

};

export default FlowLaunchesChart;
